<template>
  <v-autocomplete
    :loading="isLoading"
    :items="transportationProfiles"
    :search-input.sync="searchKey"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    class="transportation-profile-autocomplete"
    :clearable="clearable"
    :multiple="multiSelect"
    item-text="licensePlateNumber"
    item-value="id"
    hide-no-data
    no-filter
    return-object
    v-model="internalValue"
    @focus="onFocus"
    @blur="onBlur"
  >
    <template slot="item" slot-scope="{ item }">
      <div style="width: 100%">
        <div class="layout row justify-start align-center">
          <div v-if="multiSelect" class="mr-2">
            <v-icon small>{{ isProfileSelected(item.id) ? 'fas fa-check-square' : 'fal fa-square' }}</v-icon>
          </div>
          <div>{{ item.licensePlateNumber }}</div>
        </div>
        <div v-if="item.currentDriverName && showDriver" class="layout row justify-start align-center">
          <div><v-icon small>fal fa-address-card</v-icon></div>
          &nbsp;
          <div>
            <small>{{ item.currentDriverName }}</small>
          </div>
        </div>
        <div v-if="showOwnerAccount" class="layout row justify-start align-center">
          <div><v-icon small>fal fa-users</v-icon></div>
          &nbsp;
          <div>
            <small>
              <span v-show="item.ownerAccountName">{{ item.ownerAccountName }}</span>
              <span v-show="!item.ownerAccountName" style="color: #ccc">Unknown account</span>
            </small>
          </div>
        </div>
        <hr style="width: 100%; border: 0; border-bottom: 1px solid #ccc" />
      </div>
    </template>
    <template v-slot:selection="{ item, index }">
      <span
        v-if="!multiSelect"
        class="selection-summary-text"
        :title="formatSelectionLabel(item)"
      >
        {{ formatSelectionLabel(item) }}
      </span>
      <template v-else-if="!isFocused">
        <span
          v-if="index === 0"
          class="selection-summary-text"
          :title="formatSelectionLabel(item)"
        >
          {{ formatSelectionLabel(item) }}
        </span>
        <v-tooltip v-else-if="index === 1" top max-width="320">
          <template v-slot:activator="{ on }">
            <span class="selection-summary-count" v-on="on">
              (+{{ selectedProfilesForDisplay.length - 1 }} more)
            </span>
          </template>
          <div
            v-for="profile in selectedProfilesForDisplay"
            :key="profile.id"
          >
            {{ formatSelectionLabel(profile) }}
          </div>
        </v-tooltip>
      </template>
    </template>
  </v-autocomplete>
</template>

<style scoped>
.selection-summary-text {
  display: inline-block;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selection-summary-count {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 8px;
  white-space: nowrap;
}

.transportation-profile-autocomplete /deep/ .v-select__selections {
  flex-wrap: nowrap;
  overflow: hidden;
}
</style>

<script>
import src from './src'

export default src
</script>
